<template>
  <div class="table-responsive">
    <table class="table table-condensed text-14 m-b-none">
      <thead>
        <tr class="text-12 text-gray-600">
          <th>Date</th>
          <th>Wrestler(s)</th>
          <th class="text-right">Duration</th>
          <th class="text-right">Revenue</th>
          <th class="text-right">Processing</th>
          <th class="text-right">Facility fee</th>
          <th class="text-right">Coach pay</th>
          <th>Parent payment</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(lesson, index) in lessons" :key="index">
          <td class="pl-slot-time">{{ formatDateTime(lesson.lesson_at) }}</td>
          <td>{{ lesson.wrestler_names }}</td>
          <td class="text-right pl-slot-time">{{ lesson.duration_minutes }} min</td>
          <td class="text-right pl-slot-time">{{ dollars(lesson.revenue) }}</td>
          <td class="text-right pl-slot-time">&minus;{{ dollars(lesson.processing_fee) }}</td>
          <td class="text-right pl-slot-time">&minus;{{ dollars(lesson.facility_cut) }}</td>
          <td class="text-right pl-slot-time font-semi">{{ dollars(lesson.coach_pay) }}</td>
          <td :class="statusClass(lesson.payment_status)">{{ lesson.payment_status }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="font-semi">
          <td colspan="3">Total</td>
          <td class="text-right pl-slot-time">{{ dollars(totals.revenue) }}</td>
          <td class="text-right pl-slot-time">&minus;{{ dollars(totals.processing_fee) }}</td>
          <td class="text-right pl-slot-time">&minus;{{ dollars(totals.facility_cut) }}</td>
          <td class="text-right pl-slot-time">{{ dollars(totals.coach_pay) }}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import { currencyMix } from '../../shared/currency_mix';

// The lesson-level breakdown behind a payroll number. Used twice on the payroll
// page: for the current owed window, and for the window of a past payout.
export default {
  name: 'payroll-lesson-table',
  mixins: [currencyMix],
  props: {
    lessons: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totals() {
      return this.lessons.reduce((sum, lesson) => ({
        revenue: sum.revenue + lesson.revenue,
        processing_fee: sum.processing_fee + lesson.processing_fee,
        facility_cut: sum.facility_cut + lesson.facility_cut,
        coach_pay: sum.coach_pay + lesson.coach_pay,
      }), {
        revenue: 0, processing_fee: 0, facility_cut: 0, coach_pay: 0,
      });
    },
  },
  methods: {
    statusClass(status) {
      if (status === 'refunded' || status === 'partially refunded') {
        return 'text-red-600';
      }
      return status === 'not collected' ? 'text-yellow-700' : 'text-green-600';
    },
    dollars(cents) {
      return this.formatAsCurrency(cents);
    },
    formatDateTime(date) {
      return moment(date).format('MMM D, YYYY h:mm a');
    },
  },
};
</script>
